import React, { useState, useEffect } from 'react';
import {
    API_UPDATE_CENTER,
    API_ADD_CENTER,
} from '../Config/ApiUrlConstant'; // Import your constants
import { AuthProvider, useAuth } from '../AuthContext'; // Import useAuth hook for access
const branches = [
    {
        "id": 1,
        "branch_no": "BRAN0001",
        "branch_name": "Mohanw"
    }
];

const AddEditCenter = ({ showAddEdit, setShowAddEdit, actionType, centerToEdit, refreshCenters }) => {
    const [formData, setFormData] = useState({
        branch_id: '',
        center_name: '',
    });
    const [message, setMessage] = useState('');
    const [modalVisible, setModalVisible] = useState(false); // Success modal visibility

    // Update form state if editing an existing center
    useEffect(() => {
        if (actionType === 'edit' && centerToEdit) {
            setFormData({
                branch_id: centerToEdit.branch_id || '',
                center_name: centerToEdit.center_name || '',
            });
        }
        if (actionType === 'add') {
            resetForm();
        }
    }, [centerToEdit, actionType]);

    // Reset form
    const resetForm = () => {
        setFormData({
            branch_id: '',
            center_name: '',
        });
    };

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const { logout } = useAuth(); // Add this at the top inside the component

    // Handle form submission (Add/Edit)
    const handleSubmit = async (e) => {
        e.preventDefault();

        const method = 'POST'; // Use PUT if editing, POST for adding
        const url = centerToEdit
            ? API_UPDATE_CENTER // Assuming center has an id field
            : API_ADD_CENTER;
        if (centerToEdit?.id) {
            formData.id = centerToEdit.id;
        }
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                },
                body: JSON.stringify(formData),
            });
            if (response.status === 401 || response.status === 403) {
                logout(); // 👈 Token invalid or expired → logout
                return;
            }
            const responseData = await response.json();
            if (responseData.status) {
                alert(responseData.message);
                setModalVisible(true); // Show success modal
                resetForm(); // Reset the form
                refreshCenters(); // Refresh the list of centers after submit
                setShowAddEdit(false); // Close the modal
            } else {
                alert(responseData.message);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    // Close the success modal and refresh the page
    const handleModalClose = () => {
        setModalVisible(false);
        refreshCenters(); // Refresh centers after closing the modal (or you could trigger page reload here)
    };

    return (
        <div className={`modal ${showAddEdit ? 'd-block' : 'd-none'}`} tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title ft-left" style={{ width: '100%' }}>
                            {centerToEdit ? 'Edit Center' : 'Add New Center'}
                        </h5>
                        <button type="button" className="close ft-right" style={{ width: '10%' }} onClick={() => setShowAddEdit(false)}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Branch No</label>
                                <select
                                    className="form-control"
                                    name="branch_id"
                                    value={formData.branch_id}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="">Select Branch</option>
                                    {branches.map(branch => (
                                        <option key={branch.id} value={branch.id}>
                                            {branch.branch_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Center Name</label>
                                <input
                                    type="text"
                                    name="center_name"
                                    className="form-control"
                                    value={formData.center_name}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowAddEdit(false)}>
                                    Close
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    {centerToEdit ? 'Update' : 'Add'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddEditCenter;